const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`f53eb453a47e106583a4c66bae3944242771130684e1f58bd3f9565e6f9cc7af`, `f53eb453a47e106583a4c66bae3944242771130684e1f58bd3f9565e6f9cc7af`, 1, 59), undefined, true, false, 1));
            }

            getTemplateName() {
                return `f53eb453a47e106583a4c66bae3944242771130684e1f58bd3f9565e6f9cc7af`;
            }

            getSourceContext() {
                return new this.Source(``, `f53eb453a47e106583a4c66bae3944242771130684e1f58bd3f9565e6f9cc7af`, ``);
            }
        }],
        [59, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `f53eb453a47e106583a4c66bae3944242771130684e1f58bd3f9565e6f9cc7af`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.createRange(1, 3));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`i`] = __value__;
                    this.echo(`      <h`);
                    this.echo(this.env.getFilter('escape').traceableCallable(4, this.source)(...[this.env, context.get(`i`), `html`, null, true]));
                    this.echo(`>
        `);
                    this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, this.env.getFilter('capitalize').traceableCallable(5, this.source)(...[this.env, (((context.has(`amount`))) ? (this.env.getFilter('default').traceableCallable(5, this.source)(...[(context.has(`amount`) ? context.get(`amount`) : null), `default`])) : (`default`))]), `html`, null, true]));
                    this.echo(` Rhythm
        `);
                    if ((context.has(`heading_amount`) ? context.get(`heading_amount`) : null)) {
                        this.echo(`          with `);
                        this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, this.env.getFilter('capitalize').traceableCallable(7, this.source)(...[this.env, (context.has(`heading_amount`) ? context.get(`heading_amount`) : null)]), `html`, null, true]));
                        this.echo(` Headings
        `);
                    }
                    this.echo(`        (H`);
                    this.echo(this.env.getFilter('escape').traceableCallable(9, this.source)(...[this.env, context.get(`i`), `html`, null, true]));
                    this.echo(`)
      </h`);
                    this.echo(this.env.getFilter('escape').traceableCallable(10, this.source)(...[this.env, context.get(`i`), `html`, null, true]));
                    this.echo(`>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam finibus id nisl eu euismod. Vivamus ornare ullamcorper ex, nec laoreet felis mollis sit amet.</p>
      `);
                    if (this.traceableMethod(this.getAttribute, 12, this.source)(this.env, context.get(`loop`), `first`, new Map([]), `any`, false, false, false)) {
                        this.echo(`        <p>Donec porta eros at tellus ornare, id dignissim dui eleifend. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>
        `);
                        this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`href`, `#`], [`label`, `Example`], [`content_end_icon`, `arrow-right`]]), false, false, 14));
                        this.echo(`      `);
                    }
                    this.echo(`    `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('i');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
            }

            getTemplateName() {
                return `f53eb453a47e106583a4c66bae3944242771130684e1f58bd3f9565e6f9cc7af`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `f53eb453a47e106583a4c66bae3944242771130684e1f58bd3f9565e6f9cc7af`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'f53eb453a47e106583a4c66bae3944242771130684e1f58bd3f9565e6f9cc7af');

let template = env.loadTemplate('f53eb453a47e106583a4c66bae3944242771130684e1f58bd3f9565e6f9cc7af');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/rhythm/demo/example.twig", args: context }
     );
     return rendered;;
};